<div class="close-row"><i (click)="closeDialog()" class="material-icons close">close</i></div>
<h1>Get the app.</h1>
<a href="#" (click)="openStore($event)" target="_blank"><img class="screenshot" src="/assets/images/RIS_Features_rewards_1.png" /></a>
<p>Get the Rollit Wealth app</p>
<a href="#" (click)="openStore($event)" target="_blank"><img src="/assets/images/app-apple.png" width="145" alt="Download Rollit Wealth"></a>